// import React from 'react'
// import style from './MediaCarousel.module.scss'

import useEmblaCarousel from 'embla-carousel-react'
import { SELECTED_MEDIA } from '../../../infrastructure/dtos/types/file'
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'
import styles from './MediaCarousel.module.scss'

export function MediaCarousel({selectedMedia: slides, clearFiles}: {selectedMedia: SELECTED_MEDIA[], clearFiles: () => void}) {
    const containerRef = useRef<HTMLDivElement>(null);
    const [pageWidth, setWidth] = useState<number>(0);
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [emblaMainRef, emblaMainApi] = useEmblaCarousel()
    const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
      containScroll: 'keepSnaps',
      dragFree: true
    });
    console.log('pageWidth', pageWidth)
    useLayoutEffect(() => {
      if (!containerRef.current) return;

      // Create observer to track real-time size changes
      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          // 'contentRect' gives you width/height
          setWidth(entry.contentRect.width);
        }
      });

      observer.observe(containerRef.current);

      // Cleanup to prevent memory leaks
      return () => observer.disconnect();
    }, []);

    const onThumbClick = useCallback(
      (index: number) => {
        if (!emblaMainApi || !emblaThumbsApi) return
        emblaMainApi.goTo(index)
      },
      [emblaMainApi, emblaThumbsApi]
    )
  
    const onSelect = useCallback(() => {
      if (!emblaMainApi || !emblaThumbsApi) return
      setSelectedIndex(emblaMainApi.selectedSnap())
      emblaThumbsApi.goTo(emblaMainApi.selectedSnap())
    }, [emblaMainApi, emblaThumbsApi, setSelectedIndex])
  
    useEffect(() => {
      if (!emblaMainApi) return
      onSelect()
  
      emblaMainApi.on('select', onSelect).on('reinit', onSelect)
    }, [emblaMainApi, onSelect])
    return (
      <div ref={containerRef} className={styles.embla}>
        <div className={styles.emblaViewport} ref={emblaMainRef}>
          <div className={styles.emblaContainer}>
            {slides.map((media, index) => (
              <div className={styles.emblaSlide} key={index}>
                {media.src && !media.isImage && <video className={styles.emblaSlideNumber} loop width={pageWidth} playsInline autoPlay key={media.src} >
                    <source src={media.src} type="video/mp4" />
                    </video>}
                {media.src && media.isImage && <img className={styles.emblaSlideNumber} width={pageWidth} src={media.src} alt='preview' />}
              </div>
            ))}
          </div>
        </div>

        <div className={styles.close} onClick={clearFiles}><span>✕</span></div>
          
        {slides.length > 1 &&(
          <div className={styles.emblaThumbs}>
            <div className={styles.emblaThumbsViewport} ref={emblaThumbsRef}>
              <div className={styles.emblaThumbsContainer}>
                {slides.map((_, index) => (
                  <div
                    key={index}
                    onClick={() => onThumbClick(index)}
                    className={index === selectedIndex ? styles.activeThumb : undefined}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
    </div>
    )
}
